import { CHCRow } from "./row.component.js";
customElements.define("chc-row", CHCRow);
export {
  CHCRow
};
//# sourceMappingURL=row.js.map
